import { useCustomMetadataModal } from "hooks/useCustomMetadataModal";
import { useModalOperatorsAndValues } from "hooks/CustomMetadata/useModalOperatorsAndValues";
import { CustomMetadata } from "types";
import { DateTimeIcon } from "assets/icons/CustomMetadataIcons";
import BaseQueryModal from "./BaseQueryModal";
import {
  formatDateForAPI,
  formatDateRangeForAPI,
} from "helpers/utility/customMetadataHelpers";
import { useDateTimeQueryModal } from "hooks/UseQueryModal/useDateTimeQueryModal";
import DateTimeSelector from "../DataTimeSelector";
import { convertAPIOperator } from "helpers/utility/queryFilterHelpers";

interface DateTimeModalProps {
  field: CustomMetadata;
  editQueryId?: string;
}

export default function InsertionTimeModal({
  editQueryId,
  field,
}: DateTimeModalProps) {
  const { modalRef, handleSubmission, fieldName, oldQuery } =
    useCustomMetadataModal({
      field,
      editQueryId,
    });

  const {
    operator,
    setOperator,
    operatorOptions,
    value,
    setValue,
    mode,
    previousValue,
    existingQuery,
  } = useModalOperatorsAndValues({
    type: "datetime",
    field,
    editQueryId,
    options: [],
  });

  const previousOperator = oldQuery?.custom_metadata?.op
    ? convertAPIOperator(oldQuery.custom_metadata.op)
    : existingQuery
      ? convertAPIOperator(existingQuery.custom_metadata.op)
      : null;

  const hasValidDate =
    !!value.single || (value.range && value.range.length === 2);

  const { isSubmitDisabled } = useDateTimeQueryModal({
    inputValue: value,
    previousValue,
    selectedOperator: operator,
    initialOperator: previousOperator,
    isValid: hasValidDate,
  });

  const handleSubmit = () => {
    if (isSubmitDisabled || !operator) return;
    let submitValue: string | string[];
    if (value.range && value.range.length === 2) {
      submitValue = formatDateRangeForAPI(value.range)!;
    } else if (value.single) {
      submitValue = formatDateForAPI(value.single)!;
    } else return;
    handleSubmission(operator, submitValue);
  };

  const operators = {
    options: operatorOptions,
    selected: operator,
    onSelect: setOperator,
  };

  return (
    <BaseQueryModal
      title={fieldName}
      keepOpenOnLoading
      modalRef={modalRef}
      icon={<DateTimeIcon />}
      isSubmitDisabled={isSubmitDisabled}
      onSubmit={handleSubmit}
      operators={operators}
    >
      <DateTimeSelector mode={mode} value={value} onChange={setValue} />
    </BaseQueryModal>
  );
}
